import React, {Component} from 'react';
import PasswordInputComponent from "./PasswordInputComponent";
import {Button, Row, Col} from "reactstrap";
import axios from "axios";
import {serverPath} from "./common";
import {Redirect} from "react-router-dom";

class PasswordResetComponent extends Component{
    constructor(props){
        super(props);
        this.state={
            newPassword:"",
            redirect : false,
            informationText: "",
        };
        this.onValidPassword = this.onValidPassword.bind(this);
        this.onInvalidPassword = this.onInvalidPassword.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
    }
    onValidPassword(pass){
        this.setState({
            newPassword:pass
        })
    }
    onInvalidPassword(){
        this.setState({
            newPassword:""
        })
    }
    handleChangePassword(){
        const pass = this.state.newPassword;
        if(pass !== ""){
            const params = new URLSearchParams();
            params.append('action', "changeForgottenPassword");
            params.append('newPassword', pass);
            params.append('userId', this.props.match.params.uid);
            params.append('token', this.props.match.params.token);
            axios.post(serverPath + "authService.php", params).then((resp)=>{
                if(resp.data.tokenValid === true){
                    this.setState({
                        informationText: "Šifra uspešno promenjena! Bićete preusmereni na početnu stranu.",
                    });
                }
                else{
                    this.setState({
                        informationText: "Kod nije validan! Bićete preusmereni na početnu stranu.",
                    });
                }
                setTimeout(()=>{
                    this.setState({
                        redirect : true,
                    })
                }, 3000);
            });
        }
    }
    render(props){
        if(this.state.redirect){
            return <Redirect to={"/"}/>
        }
        else{
            return(
                <Row>
                    <Col xs={2}/>
                    <Col>
                        <PasswordInputComponent
                            onValidPassword={this.onValidPassword}
                            onInvalidPassword={this.onInvalidPassword}
                        />
                        <Button color={'primary'}
                                onClick={this.handleChangePassword}>
                            Promenite šifru
                        </Button>
                        <h3>{this.state.informationText}</h3>
                    </Col>
                    <Col xs={2}/>
                </Row>
            )
        }
    }
}

export default PasswordResetComponent;